import global from './global.json';
import en from './en.json';
import en_US from './en-US.json';
import es_ES from './es-ES.json';
import pt_PT from './pt-PT.json';

const fileMap = {
  global,
  en,
  'en-US': en_US,
  'es-ES': es_ES,
  'pt-PT': pt_PT,
};

export default fileMap;
